import React from 'react';
import SessionStates from '../../../core/session/session-states';
import OpeningAnimation from './OpeningAnimation';
import LogoutDialog from './LogoutDialog';

function LoadingScreen(props) {
  const { sessionState, farewell } = props;
  const reverse = sessionState === SessionStates.SUSPENDED;
  // Antes só renderizava com ALIVE ou SUSPENDED — quando sessionState era
  // undefined (entre o React mount e o handshake), ficava tela branca
  // por baixo do .sf-boot HTML estático sendo destruído. Agora cobrimos
  // sempre, exceto no estado ENDED (que mostra o LogoutDialog).
  const isEnded = sessionState === SessionStates.ENDED;

  return (
    <>
      {!isEnded && <OpeningAnimation reverse={reverse} farewell={farewell} />}
      {isEnded && <LogoutDialog />}
    </>
  );
}

export default LoadingScreen;
